import { FunctionComponent } from 'react';
import SolutionProductsWrapper from './solutionProduct.style';
import { getStaticImageUrl } from '@utils/createImageUrl';

const SolutionProducts: FunctionComponent = () => {
  const solutionProducts = [
    {
      title: '15분 전화상담',
      desktopImage: getStaticImageUrl({ fileName: 'solution-phone_desktop.jpg' }),
      mobileImage: getStaticImageUrl({ fileName: 'solution-phone_mobile.jpg' }),
      description: '상담을 결제/예약한 의뢰인에게 변호사님이 직접 전화를 걸어 15분간 상담합니다.',
      isOpen: true,
    },
    {
      title: '20분 영상상담',
      desktopImage: getStaticImageUrl({ fileName: 'solution-video_desktop.jpg' }),
      mobileImage: getStaticImageUrl({ fileName: 'solution-video_mobile.jpg' }),
      description: 'PC, 모바일 디바이스 등을 통해 공간의 제약없이 의뢰인에게 깊이있는 상담 서비스 제공이 가능합니다.',
      isOpen: true,
    },
    {
      title: '30분 방문상담',
      desktopImage: getStaticImageUrl({ fileName: 'solution-visit_desktop.jpg' }),
      mobileImage: getStaticImageUrl({ fileName: 'solution-visit_mobile.jpg' }),
      description: '상담을 결제/예약한 의뢰인이 변호사님 사무실로 방문하면 30분간 상담을 진행합니다.',
      isOpen: true,
    },
  ];
  return (
    <SolutionProductsWrapper>
      <div className="solutionproducts--header">
        <p className="solutionproducts--header-title">
          법률상담,
          <br />
          <span>원하는 시간과 금액</span>으로
          <br />
          의뢰인에게 제공하세요
        </p>
        <p className="solutionproducts--header-desc">
          법률상담 선결제 솔루션이란 변호사님이 원하시는 상담시간 및 금액으로 예약한 의뢰인과 전화/방문으로 상담을
          진행하는 솔루션입니다.
        </p>
      </div>
      <div className="solutionproducts--body">
        <div className="solutionproducts--products">
          {solutionProducts.map((solutionProduct, index) => (
            <div className="solutionproducts--product" key={index}>
              <img className="solutionproducts--product-image desktop-image" src={solutionProduct.desktopImage} />
              <img className="solutionproducts--product-image mobile-image" src={solutionProduct.mobileImage} />

              <div className="solutionproducts--product-header">
                <p className="solutionproducts--product-title">{solutionProduct.title}</p>
                {!solutionProduct.isOpen && <span className="solutionproducts--product-ready">준비중</span>}
              </div>
              <p className="solutionproducts--product-desc">{solutionProduct.description}</p>
            </div>
          ))}
          <div className="solutionproducts--product-vacuum mobile" />
        </div>
      </div>
    </SolutionProductsWrapper>
  );
};

export default SolutionProducts;
